module.exports = __webpack_public_path__ + "static/media/graphNoDataImage.192fa705.svg";